import actionTypes from "./actionTypes";
import api from "./api";
export default {
    actionApiGetBalance: () => ({
        type: actionTypes.API_GET_BALANCE,
        payload: {
            promise: api.apiGetBalance
        }
    }),
    actionApiGetRequestStatistics: () => ({
        type: actionTypes.API_GET_REQUEST_STATISTICS,
        payload: {
            promise: api.apiGetRequestStatistics
        }
    })
};
